import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PokerBespokeLobbyWidget" */ './PokerBespokeLobbyWidget'),
  modules: ['./PokerBespokeLobbyWidget'],
  loading: () => <div />
});

export default LoadableWidget;
